import React from 'react';
import './UpcomingBooks.css';

const BookIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.25)" strokeWidth="1.5">
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
  </svg>
);

const upcomingData = [
  {
    badge: 'COMING 2026',
    genre: 'Political Thriller',
    title: 'Title Coming Soon',
    desc: 'The follow-up to Saving Grace. Anthony Grace returns in a new thriller that takes him deeper into the corridors of power — where the stakes are even higher and the enemies closer than ever.',
  },
  {
    badge: 'COMING 2027',
    genre: 'New Series',
    title: 'Title Coming Soon',
    desc: "A brand new series from Atiba. Details are under wraps — but if you loved Saving Grace, you won't want to miss what's next.",
  },
];

function UpcomingBooks() {
  return (
    <section className="upcoming-section">
      <div className="upcoming-inner">
        <div className="upcoming-header reveal">
          <h2>COMING SOON FROM ATIBA</h2>
          <div className="red-rule"></div>
        </div>
        <div className="upcoming-grid">
          {upcomingData.map((book, i) => (
            <div className="upcoming-card reveal" key={i}>
              <div className="upcoming-cover">
                <div className="upcoming-placeholder">
                  <span className="upcoming-badge">{book.badge}</span>
                  <BookIcon />
                </div>
              </div>
              <div className="upcoming-info">
                <p className="upcoming-genre">{book.genre}</p>
                <h3 className="upcoming-title">{book.title}</h3>
                <p className="upcoming-desc">{book.desc}</p>
                <p className="upcoming-notify">
                  <a href="#signup">Get notified when it drops &rarr;</a>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default UpcomingBooks;
